import React from 'react';
import { C } from './publicStyles';

export default function ScreenshotFrame({ src, alt, caption }) {
  return (
    <figure style={{ margin: 0 }}>
      <div style={{
        background: C.card, border: `1px solid ${C.border}`, borderRadius: 10,
        overflow: 'hidden', boxShadow: '0 12px 40px rgba(0,0,0,0.45)',
      }}>
        {src ? (
          <img src={src} alt={alt} style={{ display: 'block', width: '100%', maxWidth: '100%' }} />
        ) : (
          <div style={{
            aspectRatio: '16 / 9', display: 'flex', alignItems: 'center',
            justifyContent: 'center', color: C.faint, fontSize: 13, letterSpacing: 1,
          }}>
            PRODUCT SCREENSHOT
          </div>
        )}
      </div>
      {caption && (
        <figcaption style={{ color: C.faint, fontSize: 12, marginTop: 8, textAlign: 'center' }}>
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
